<template>
  <fragment>
    <b-button id="tooltip-target-1" variant="link" size="sm" class="pw-policy-button" v-b-tooltip.hover>
      {{ $t("password-policy") }}
    </b-button>
    <b-tooltip
      target="tooltip-target-1"
      triggers="hover"
      container="tooltip-target-1"
      boundary="viewport"
      placement="bottom"
    >
      <ol class="pw-policy-list">
        <li
          class="pw-policy-list__item"
          v-for="desc of descriptions"
          :key="desc"
        >
          {{ desc }}
        </li>
      </ol>
    </b-tooltip>
  </fragment>
</template>

<script>
import { UserApi } from "nx-libs";

export default {
  data() {
    return {
      descriptions: []
    };
  },
  async created() {
    this.descriptions = (await UserApi.getPasswordHints()).data;
  },
  computed: {
    name() {
      return this.label || this.$t("new-password");
    }
  }
};
</script>

<style lang="scss" scoped>
.pw-policy-list {
  padding-left: 1rem;
  &__item {
    text-align: left;
  }
}
.pw-policy-button {
  padding: 0rem;
}
</style>

<i18n src="@/locales/login.locale.json" />
